import { z } from 'zod'

export const MEMBERSHIP_SESSIONS_REVOKE_CONTRACT_VERSION = '1.0.0' as const

export const membershipSessionsRevokeResponseSchema = z.record(z.unknown())

export type MembershipSessionsRevokeResponse = z.infer<typeof membershipSessionsRevokeResponseSchema>
